import api from "@/lib/axios";

export const getListJalurJenis = async () => {
  const response = await api.get("/master/jalur-jenis/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenjangPendidikan = async () => {
  const response = await api.get("/master/jenjang-pendidikan/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListProgramStudentExchange = async () => {
  const response = await api.get("/master/daftar-program/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListPekerjaan = async () => {
  const response = await api.get("/master/pekerjaan/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisBerkas = async () => {
  const response = await api.get("/master/jenis-berkas/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListPeriode = async (
  tahun?: string,
  id_ref_jalur_jenis?: string,
) => {
  const params = new URLSearchParams(location.search);
  if (tahun) params.append("tahun", tahun);
  if (id_ref_jalur_jenis)
    params.append("id_ref_jalur_jenis", id_ref_jalur_jenis);

  const response = await api.get(
    `/setting/periode/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getPeriode = async (id: string) => {
  const response = await api.get(`/setting/periode/show/${id}`, {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getPeriodeCustom = async (id: string) => {
  const response = await api.get(
    `/siswa/periode-custom/show?id_sys_periode=${id}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListUnitkerja = async () => {
  const response = await api.get("/master/unit-kerja/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListProgramStudiPerPeriode = async (
  id_sys_periode?: string,
) => {
  const params = new URLSearchParams(id_sys_periode);
  if (id_sys_periode) params.append("id_sys_periode", id_sys_periode);

  const response = await api.get(
    `/data-siswa/get-program-studi?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListProgramStudiPerPeriodePasca = async (
  id_sys_periode?: string,
) => {
  const params = new URLSearchParams(id_sys_periode);
  if (id_sys_periode) params.append("id_sys_periode", id_sys_periode);

  const response = await api.get(
    `/operator-pasca/data-pendaftaran/get-program-studi?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListWilayah = async (
  limit?: number,
  id_feeder_level_wilayah?: string,
  id_feeder_induk_wilayah?: string,
  id_ref_wilayah?: string,
  searchQuery?: string,
) => {
  const params = new URLSearchParams();

  if (limit) params.append("limit", limit.toString());

  if (id_feeder_level_wilayah)
    params.append(
      "id_feeder_level_wilayah",
      id_feeder_level_wilayah.toString(),
    );

  if (id_feeder_induk_wilayah) {
    params.append(
      "id_feeder_induk_wilayah",
      id_feeder_induk_wilayah.toString(),
    );
  }

  if (id_ref_wilayah) {
    params.append("id_ref_wilayah", id_ref_wilayah.toString());
  }

  if (searchQuery) {
    params.append("search", searchQuery.toString());
  }

  const response = await api.get(`/master/wilayah/index?${params.toString()}`, {
    withCredentials: true,
  });

  return response.data?.data;
};

export const getListPenghasilan = async () => {
  const response = await api.get("/master/penghasilan/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisAset = async () => {
  const response = await api.get("/master/jenis-aset/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListKepemilikanAset = async () => {
  const response = await api.get("/master/kepemilikan-aset/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListTeganganListrikAset = async () => {
  const response = await api.get("/master/tegangan-listrik-aset/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListNegara = async () => {
  const response = await api.get("/master/negara/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListAgama = async () => {
  const response = await api.get("/master/agama/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisTinggal = async () => {
  const response = await api.get("/master/jenis-tinggal/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListAlatTransportasi = async () => {
  const response = await api.get("/master/alat-transportasi/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSekolah = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string,
) => {
  const response = await api.get(
    `/master/sekolah/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListPerguruanTinggi = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string | undefined,
) => {
  const response = await api.get(
    `/master/pt/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data?.data;
};

export const getListPerguruanTinggiProdi = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string,
  isJalurProfesi?: boolean,
) => {
  const response = await api.get(
    `/master/pt-prodi/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""} ${
      isJalurProfesi ? `&isJalurProfesi=${isJalurProfesi}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data?.data;
};

// export const getListPerguruanTinggiProdiProdi = async (
//   kode_perguruan_tinggi: string
// ) => {
//   const response = await api.get(
//     `/master/pt-prodi/prodi/${kode_perguruan_tinggi}`,
//     {
//       withCredentials: true,
//     }
//   );
//   return response.data?.data;
// };

export const getListKebutuhanKhusus = async () => {
  const response = await api.get("/master/kebutuhan-khusus/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListHubunganKeluarga = async (is_aktif?: number) => {
  const response = await api.get("/master/hubungan-keluarga/index", {
    withCredentials: true,
    params: is_aktif !== undefined ? { is_aktif } : {},
  });
  return response.data?.data;
};

export const getListPangkatGolongan = async () => {
  const response = await api.get("/master/pangkat-golongan/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListLuasAset = async () => {
  const response = await api.get("/master/luas-aset/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSumberListrik = async () => {
  const response = await api.get("/master/sumber-listrik/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSumberAir = async () => {
  const response = await api.get("/master/sumber-air/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListPembayaranAirAset = async () => {
  const response = await api.get("/master/pembayaran-air-aset/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJumlahTanggungan = async () => {
  const response = await api.get("/master/jumlah-tanggungan/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisBiaya = async () => {
  const response = await api.get("/master/jenis-biaya/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisUkt = async () => {
  const response = await api.get("/master/jenis-ukt/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListUser = async (
  searchQueryVerifikator: string,
  limit: number,
  role: string,
) => {
  const params = new URLSearchParams();
  if (searchQueryVerifikator) params.append("nama", searchQueryVerifikator);
  if (limit) params.append("limit", String(limit));
  if (role) params.append("role", role);

  const response = await api.get(`/master/user/index?${params.toString()}`);
  return response.data;
};

export const getListSDM = async (
  jenis?: string,
  nama?: string,
  limit?: number,
) => {
  const params = new URLSearchParams();

  if (jenis) params.append("jenis", jenis.toString());
  if (nama) params.append("nama", nama.toString());
  if (limit) params.append("limit", limit.toString());

  const response = await api.get(`/master/sdm/index?${params.toString()}`, {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListLayananPlaza = async () => {
  const response = await api.get("/master/layanan-plaza/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSubLayanan2Plaza = async () => {
  const response = await api.get("/master/layanan-plaza/sublayanan2", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSubStatusPlaza = async () => {
  const response = await api.get("/master/layanan-plaza/substatus", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListParentKomponenPenilaian = async () => {
  const response = await api.get(
    "/operator-pasca/komponen-penilaian/parent-komponen",
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListKomponenPenilaian = async () => {
  const response = await api.get(
    "/operator-pasca/komponen-penilaian/komponen",
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListBobotKomponenPenilaian = async () => {
  const response = await api.get(
    "/operator-pasca/komponen-penilaian/bobot-komponen",
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListBobotKomponenKaryatulis = async () => {
  const response = await api.get(
    "/operator-pasca/komponen-penilaian/bobot-komponen-karyatulis",
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getMaintenanceStatus = async () => {
  const response = await api.get("/setting/maintenance/status");
  return response.data;
};

export const getDataStep = async (idSysPeriodeParams?: string) => {
  const response = await api.get(
    `/siswa/step/show${
      idSysPeriodeParams ? `?id_sys_periode=${idSysPeriodeParams}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getBiodata = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/biodata/show?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListJenisPrestasi = async () => {
  const response = await api.get("/master/jenis-prestasi/index");
  return response.data?.data;
};

export const getListJenjangPrestasi = async () => {
  const response = await api.get("/master/jenjang-prestasi/index");
  return response.data?.data;
};

export const getListGrupPrestasi = async () => {
  const response = await api.get("/master/grup-prestasi/index");
  return response.data?.data;
};

export const getListCapaianPrestasi = async () => {
  const response = await api.get("/master/capaian-prestasi/index");
  return response.data?.data;
};

export const getListProdiPerPeriode = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/pilihan-prodi/list-prodi?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListUktPerProdi = async (uk_ids: string[]) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/pilihan-prodi/list-ukt?uk_ids=${uk_ids.join(",")}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListDataPilihanProdi = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/pilihan-prodi/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListMataPelajaran = async () => {
  const response = await api.get("/sinkron/nilai-rapor-snbp/ref-mapel", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListNilaiRapor = async (
  page: string,
  rowsPerPage: string,
  search: string,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", String(page));
  if (rowsPerPage) params.append("rowsPerPage", String(rowsPerPage));
  if (search) params.append("search", String(search));

  const response = await api.get(
    `/sinkron/nilai-rapor-snbp/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListNilaiCbt = async (
  page: string,
  rowsPerPage: string,
  search: string,
  tahun: number,
) => {
  const response = await api.get(`/sinkron/nilai-cbt/index`, {
    withCredentials: true,
    params: { page, rowsPerPage, search, tahun },
  });
  return response.data?.data;
};

export const getListNilaiRaporPenerimaan = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/nilai-rapor/index?id_sys_periode=${id_sys_periode}`,
  );
  return response.data?.data;
};

export const getListDataPembayaranUkt = async () => {
  const response = await api.get("/sinkron/pembayaran-ukt/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListRuangCbt = async (tahun: string) => {
  const response = await api.get("/setting/ruang-cbt/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data?.data;
};

export const getListJurusanSekolah = async (bentuk_pendidikan?: string) => {
  const response = await api.get(
    `/master/jurusan-sekolah/index${
      bentuk_pendidikan ? `?bentuk_pendidikan=${bentuk_pendidikan}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListMapelKumer = async () => {
  const response = await api.get(`/master/mapel-peminatan-kumer/index`, {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListKonsentrasiProdi = async () => {
  const response = await api.get("/master/konsentrasi-prodi/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getDataSiswa = async () => {
  const response = await api.get(`/siswa/data-siswa/show`, {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getDataSekolahAsal = async () => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/pilihan-prodi/data-sekolah-asal/show`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getMappingJurusanSekolah = async (
  id_sys_periode: string,
  uk_id: string,
) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/pilihan-prodi/show-jurusan-sekolah?id_sys_periode=${id_sys_periode}&uk_id=${uk_id}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListProgram = async () => {
  const response = await api.get("/master/daftar-program/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListSertifikatTteSumber = async (tahun: number) => {
  const response = await api.get("/penerimaan/sertifikat-cbt/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data?.data;
};

// DAFTAR KEMBALI
export const getDataSiswaLengkap = async (id_sys_periode?: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/biodata/show${
      id_sys_periode ? `?id_sys_periode=${id_sys_periode}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListDataKeluarga = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/data-keluarga/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getDataKeluargaTambahan = async (id_data_pendaftaran: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/data-keluarga/show/data-keluarga-tambahan/${id_data_pendaftaran}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListDataAset = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/data-aset/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListBerkas = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/data-berkas/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListBerkasPenerimaan = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/data-berkas/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListBerkasPortofolio = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/portofolio/index?id_sys_periode=${id_sys_periode}`,
  );
  return response.data?.data;
};

export const getListBerkasInvalid = async (id_sys_periode?: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/data-berkas/invalid/index?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getDataSurvey = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/survey/show?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListKomponenDashboardSiswa = async (search?: string) => {
  const response = await api.get(
    `/siswa/dashboard${search ? `?search=${search}` : ""}`,
    {
      withCredentials: true,
    },
  );

  return response.data?.data;
};

export const getListKomponenDashboardSiswaRpl = async (search?: string) => {
  const response = await api.get(
    `/siswa/dashboard-rpl${search ? `?search=${search}` : ""}`,
    {
      withCredentials: true,
    },
  );

  return response.data?.data;
};

export const getDataStatusValidasiPermanen = async (
  idSysPeriodeParams?: string,
) => {
  const response = await api.get(
    `/siswa/daftar-kembali/status-validasi-permanen${
      idSysPeriodeParams ? `?id_sys_periode=${idSysPeriodeParams}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getDataStatusIsiUKTPenerimaKIPK = async (
  idSysPeriodeParams?: string,
) => {
  const response = await api.get(
    `/siswa/daftar-kembali/status-isi-ukt-penerima-kipk${
      idSysPeriodeParams ? `?id_sys_periode=${idSysPeriodeParams}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data ?? null;
};

export const getStatusPembayaranBriva = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/daftar-kembali/cek-status-pembayaran-briva?id_sys_periode=${id_sys_periode}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getMasterSystem = async () => {
  const response = await api.get("/setting/sys-master/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

//

// VERIFIKASI BERKAS UKT
export const getListPesertaVerifikasi = async (
  page: string | undefined,
  rowsPerPage: string | undefined,
  search: string | undefined,
  statusValidasi: string | undefined,
  jenisVerifikatorUkt: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (rowsPerPage) params.append("rowsPerPage", rowsPerPage);
  if (search) params.append("search", search);
  if (statusValidasi) params.append("statusValidasi", statusValidasi);
  if (jenisVerifikatorUkt)
    params.append("jenisVerifikatorUkt", jenisVerifikatorUkt);

  const response = await api.get(
    `/verifikator/peserta/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};
//

// VERIFIKASI PESERTA BUTAWARNA
export const getListPesertaVerifikasiButawarna = async (
  page: string | undefined,
  rowsPerPage: string | undefined,
  search: string | undefined,
  statusValidasi: string | undefined,
  jenisVerifikator: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (rowsPerPage) params.append("rowsPerPage", rowsPerPage);
  if (search) params.append("search", search);
  if (statusValidasi) params.append("statusValidasi", statusValidasi);
  if (jenisVerifikator) params.append("jenis_verifikator", jenisVerifikator);

  const response = await api.get(
    `/verifikator/peserta-butawarna/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListPesertaVerifikasiSehat = async (
  page: string | undefined,
  rowsPerPage: string | undefined,
  search: string | undefined,
  statusValidasi: string | undefined,
  jenisVerifikator: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (rowsPerPage) params.append("rowsPerPage", rowsPerPage);
  if (search) params.append("search", search);
  if (statusValidasi) params.append("statusValidasi", statusValidasi);
  if (jenisVerifikator) params.append("jenis_verifikator", jenisVerifikator);

  const response = await api.get(
    `/verifikator/peserta-surat-keterangan-sehat/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListPesertaVerifikasiRaport = async (
  page: string | undefined,
  rowsPerPage: string | undefined,
  search: string | undefined,
  statusValidasi: string | undefined,
  ukIdsParams?: string | undefined,
  jenisVerifikatorParams?: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (rowsPerPage) params.append("rowsPerPage", rowsPerPage);
  if (search) params.append("search", search);
  if (statusValidasi) params.append("statusValidasi", statusValidasi);
  if (ukIdsParams) params.append("uk_ids", ukIdsParams);
  if (jenisVerifikatorParams)
    params.append("jenis_verifikator", jenisVerifikatorParams);

  const response = await api.get(
    `/verifikator/peserta-ijazah/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export const getListPesertaVerifikasiSkl = async (
  page: string | undefined,
  rowsPerPage: string | undefined,
  search: string | undefined,
  statusValidasi: string | undefined,
  ukIdsParams?: string | undefined,
  jenisVerifikatorParams?: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (rowsPerPage) params.append("rowsPerPage", rowsPerPage);
  if (search) params.append("search", search);
  if (statusValidasi) params.append("statusValidasi", statusValidasi);
  if (ukIdsParams) params.append("uk_ids", ukIdsParams);
  if (jenisVerifikatorParams)
    params.append("jenis_verifikator", jenisVerifikatorParams);

  const response = await api.get(
    `/verifikator/peserta-skl/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

//

export const getListJalurFeeder = async () => {
  const response = await api.get("/master/feeder/jalur", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListJenisDaftarFeeder = async () => {
  const response = await api.get("/master/feeder/jenis-daftar", {
    withCredentials: true,
  });
  return response.data?.data;
};

export const getListPrestasi = async (id_sys_periode: string) => {
  const response = await api.get(
    `/siswa/penerimaan/smbjm/prestasi/index?id_sys_periode=${id_sys_periode}`,
  );
  return response.data?.data;
};

export const getLinimasa = async () => {
  const response = await api.get("/linimasa");
  return response.data?.data;
};

export const getTimeServer = async () => {
  const response = await api.get("/time-server");
  return response.data?.data;
};

export const getLinimasaUnregular = async (slug: string) => {
  const response = await api.get("/linimasa-unregular", {
    params: { nama_jalur_jenis_slug: slug },
  });
  return response.data?.data[0];
};

// VERIFIKASI IJAZAH DAN NILAI RAPOR
export const getDataVerifikasiIjazah = async (nomor_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/peserta-ijazah/show/ijazah/${nomor_pendaftaran}`,
  );
  return response.data?.data;
};

export const getDataVerifikasiSkl = async (nomor_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/peserta-skl/show/skl/${nomor_pendaftaran}`,
  );
  return response.data?.data;
};

export const getDataVerifikasiButawarna = async (nomor_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/peserta-butawarna/show/berkas-butawarna/${nomor_pendaftaran}`,
  );
  return response.data?.data;
};

export const getDataVerifikasiSehat = async (nomor_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/peserta-surat-keterangan-sehat/show/berkas/${nomor_pendaftaran}`,
  );
  return response.data?.data;
};
//

export const getDataRekapPendaftaran = async (
  ids_ref_jalur_jenis?: string,
  tahun?: string,
) => {
  const params = new URLSearchParams(location.search);

  if (ids_ref_jalur_jenis)
    params.append("id_ref_jalur_jenis", ids_ref_jalur_jenis);
  if (tahun) params.append("tahun", tahun);

  const response = await api.get(
    `/dashboard/rekap-pendaftaran-smbjm?${params.toString()}`,
  );
  return response.data?.data;
};

export const getDataRekapPendaftaranKembali = async (
  ids_ref_jalur_jenis?: string,
  ids_uk?: string,
  tahun?: string,
  ids_fakultas?: string,
) => {
  const params = new URLSearchParams(location.search);

  if (ids_ref_jalur_jenis)
    params.append("ids_ref_jalur_jenis", ids_ref_jalur_jenis);
  if (ids_uk) params.append("ids_uk", ids_uk);
  if (tahun) params.append("tahun", tahun);
  if (ids_fakultas) params.append("ids_fakultas", ids_fakultas);

  const response = await api.get(
    `/dashboard/rekap-pendaftaran?${params.toString()}`,
  );
  return response.data?.data;
};

export const getDataRekapPendaftaranPerbandinganTahunan = async (
  ids_ref_jalur_jenis?: string,
  ids_uk?: string,
  tahun?: string,
  ids_fakultas?: string,
) => {
  const params = new URLSearchParams(location.search);

  if (ids_ref_jalur_jenis)
    params.append("ids_ref_jalur_jenis", ids_ref_jalur_jenis);
  if (ids_uk) params.append("ids_uk", ids_uk);
  if (tahun) params.append("tahun", tahun);
  if (ids_fakultas) params.append("ids_fakultas", ids_fakultas);

  const response = await api.get(
    `/dashboard/rekap-pendaftaran/perbandingan-tahunan?${params.toString()}`,
  );
  return response.data?.data;
};

export const getListDesil = async () => {
  const response = await api.get("/master/ref-desil/index", {
    withCredentials: true,
  });
  return response.data?.data;
};
